<template>
  <div>
    <h1>Member Account Resources and Contacts</h1>
    <h2>Qualification Contact</h2>
    <b-row>
      <b-col md="8" lg="6" xl="4">
        <p>          
          This contact (individual or email alias) will receive communications regarding 
          your Bluetooth Qualification Program and issues regarding your company’s qualifications. 
          By default, this information is visible to all users from your company.
        </p>
      </b-col>
    </b-row>
    <!-- forms -->
    <b-row>
      <!-- security contact form -->
      <b-col class="mt-3" md="8" lg="6" xl="4">
        <ContactForm title="Qualification Contact" memberContactType="5" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ContactForm from "@/components/ContactForm";
export default {
  name: "Qualification",
  components: { ContactForm }
};
</script>
